import { createSlice } from "@reduxjs/toolkit";

export const materialSlice = createSlice({
    name: "ihgroupmaterial",
    initialState: {
        materials: [],
        isFetching: false,
        error: false,
    },
    reducers: {
        //GET ALL
        getMaterialStart: (state) => {
            state.isFetching = true;
            state.error = false;
        },
        getMaterialSuccess: (state, action) => {
            state.isFetching = false;
            state.materials = action.payload;
        },
        getMaterialFailure: (state) => {
            state.isFetching = false;
            state.error = true;
        },
        //DELETE
        deleteMaterialStart: (state) => {
            state.isFetching = true;
            state.error = false;
        },
        deleteMaterialSuccess: (state, action) => {
            state.isFetching = false;
            state.materials.splice(
                state.materials.findIndex((item) => item._id === action.payload),
                1
            );
        },
        deleteMaterialFailure: (state) => {
            state.isFetching = false;
            state.error = true;
        },
        //UPDATE
        updateMaterialStart: (state) => {
            state.isFetching = true;
            state.error = false;
        },
        updateMaterialSuccess: (state, action) => {
            state.isFetching = false;
            state.materials[
                state.materials.findIndex(
                    (item) => item._id === action.payload.id
                )
            ] = action.payload.material;
        },
        updateMaterialFailure: (state) => {
            state.isFetching = false;
            state.error = true;
        },
        //ADD
        addMaterialStart: (state) => {
            state.isFetching = true;
            state.error = false;
        },
        addMaterialSuccess: (state, action) => {
            state.isFetching = false;
            state.materials.push(action.payload);
        },
        addMaterialFailure: (state) => {
            state.isFetching = false;
            state.error = true;
        },
    },
});

export const {
    getMaterialStart,
    getMaterialSuccess,
    getMaterialFailure,
    deleteMaterialStart,
    deleteMaterialSuccess,
    deleteMaterialFailure,
    updateMaterialStart,
    updateMaterialSuccess,
    updateMaterialFailure,
    addMaterialStart,
    addMaterialSuccess,
    addMaterialFailure,
} = materialSlice.actions;

export default materialSlice.reducer;
